import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./ButtonsMenu.css";
import {
    FormatListBulleted as FormatListBulletedIcon,
    LibraryBooks as LibraryBooksIcon,
    MailOutlined as MailOutlinedIcon,
    AutoStoriesOutlined as AutoStoriesOutlinedIcon,
    ErrorOutline as ErrorOutlineIcon,
    Engineering as EngineeringIcon,
    Assignment as AssignmentIcon,
    Analytics as AnalyticsIcon,
    Close as CloseIcon,
    Construction as ConstructionIcon,
} from "@mui/icons-material";

function ButtonsMenu() {
    const [modalOpen, setModalOpen] = useState(false);
    const [modalContent, setModalContent] = useState({ key: "", title: "", description: "" });

    const buttons = [
        { to: "/diagram", className: "order-button", icon: FormatListBulletedIcon, text: "Заказы" },
        { to: "/resources", className: "resource-button", icon: EngineeringIcon, text: "Ресурсы" },
        { to: "/reports", className: "report-button", icon: AssignmentIcon, text: "Отчёты" },
        { to: "/statistics", className: "statistics-button", icon: AnalyticsIcon, text: "Статистика" },
        { to: "/journal", className: "journal-button", icon: AutoStoriesOutlinedIcon, text: "Журнал" },
        // Почта — теперь активная ссылка на отдельную страницу
        { to: "/mail", className: "mail-button", icon: MailOutlinedIcon, text: "Почта" },
    ];

    const inDevelopmentButtons = [
        {
            key: "notification",
            className: "notification-button",
            icon: ErrorOutlineIcon,
            text: "Предупреждения",
            title: "⚠️ Система предупреждений",
            description: "Модуль уведомлений и оповещений о критических событиях находится в разработке. В ближайшее время вы сможете настраивать триггеры, получать уведомления и отслеживать важные события системы."
        },
    ];

    const handleInDevelopmentClick = (button) => {
        setModalContent({
            key: button.key,
            title: button.title,
            description: button.description
        });
        setModalOpen(true);
    };

    const closeModal = () => {
        setModalOpen(false);
    };

    return (
        <>
            <div className="buttons-container">
                <div className="section-header">
                    <h1>Панель управления MAS-IOT</h1>
                    <p>Выберите нужный раздел для управления системой</p>
                </div>

                <div className="buttons-grid">
                    {buttons.map((button, index) => (
                        <Link key={index} to={button.to} className={`menu-button ${button.className}`}>
                            <button.icon className="button-icon" />
                            <span className="button-text">{button.text}</span>
                        </Link>
                    ))}

                    {inDevelopmentButtons.map((button) => (
                        <button
                            key={button.key}
                            className={`menu-button ${button.className} in-development`}
                            onClick={() => handleInDevelopmentClick(button)}
                        >
                            <button.icon className="button-icon" />
                            <span className="button-text">{button.text}</span>
                            <span className="development-badge">В разработке</span>
                        </button>
                    ))}
                </div>

                <div className="development-info">
                    <ConstructionIcon className="construction-icon" />
                    <p>Мы постоянно работаем над улучшением системы. Скоро появятся новые функции!</p>
                </div>
            </div>

            {/* Модальное окно (только для "в разработке") */}
            {modalOpen && (
                <div className="modal-overlay" onClick={closeModal}>
                    <div className="modal-container" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h2 className="modal-title">
                                <ConstructionIcon className="modal-title-icon" />
                                {modalContent.title}
                            </h2>
                            <button className="modal-close" onClick={closeModal}>
                                <CloseIcon />
                            </button>
                        </div>

                        <div className="modal-content">
                            <div className="modal-icon-container">
                                <div className="modal-icon-circle">
                                    <ConstructionIcon className="modal-main-icon" />
                                </div>
                            </div>

                            <h3 className="modal-subtitle">Функция находится в разработке</h3>

                            <p className="modal-description">{modalContent.description}</p>

                            <div className="modal-features">
                                <h4>Что будет доступно:</h4>
                                <ul className="features-list">
                                    <li>🔔 Настройка триггеров оповещений</li>
                                    <li>📱 Push-уведомления</li>
                                    <li>📧 Email-рассылка</li>
                                    <li>📈 История событий</li>
                                    <li>⚙️ Гибкая настройка правил</li>
                                </ul>
                            </div>

                            <div className="modal-progress">
                                <div className="progress-bar-container">
                                    <div className="progress-bar">
                                        <div className="progress-fill" style={{ width: '65%' }}></div>
                                    </div>
                                    <span className="progress-text">Разработка завершена на 65%</span>
                                </div>
                                <p className="estimated-time">Ориентировочное время запуска: 2-3 недели</p>
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button className="modal-button primary" onClick={closeModal}>
                                Понятно, ждём!
                            </button>
                            <button className="modal-button secondary">
                                Получить уведомление о запуске
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default ButtonsMenu;